import type { LumpsumAllocationCategory, LumpsumAllocationNoActionFund } from '../../../../api/allocation.types'
import {
  PlanCategoryBucketKey,
  PLAN_CATEGORY_BUCKET_TITLES,
  PlansPlanMode,
  type PlansActionFilter
} from '../../../../api/types'
import { usePlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../lumpsum-ui-components/BucketAccordion'
import { AllocationNoActionFundCard } from '../cards/AllocationNoActionFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansLumpsumListEventIds, PlansScreen } from '../../../../../analytics/plansEvents'

type AllocationNoActionBucketAccordionProps = {
  category: LumpsumAllocationCategory
  categoryId: string
  actionFilter: PlansActionFilter
  isBorderTop?: boolean
}

export function AllocationNoActionBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: AllocationNoActionBucketAccordionProps) {
  const noActionFunds = getCategoryBucketItems<LumpsumAllocationNoActionFund>(category?.noActionFunds)
  const { bucketCompositeKey, isExpanded, toggle } = usePlanCategoryBucket({
    planMode: PlansPlanMode.ALLOCATION,
    actionFilter,
    categoryId,
    bucketKey: PlanCategoryBucketKey.noActionFunds
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.noActionFunds]}
      count={noActionFunds.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.LumpsumAllocation,
            eventId: PlansLumpsumListEventIds.BucketAccordion,
            buttonLabel: PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.noActionFunds]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {noActionFunds.map((fund, fundIndex) => (
        <AllocationNoActionFundCard
          key={`${fund?.isin ?? 'fund'}-${fundIndex}`}
          fund={fund}
          categoryName={category?.categoryName ?? ''}
          showBottomDivider={fundIndex < noActionFunds.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
